<template>
  <div>
    <ais-instant-search :search-client="algoliaClient" :index-name="indexName">
      <div class="hidden mb-16 md:block">
        <p class="mb-8 text-xl font-bold text-center text-blue-gray">
          Advanced Heat Pump Improvements
        </p>
        <ais-menu attribute="title">
          <ul
            class="flex flex-row flex-wrap justify-center mx-auto w-full"
            slot-scope="{
              items,
              canToggleShowMore,
              isShowingMore,
              toggleShowMore,
              refine,
              createURL,
            }"
          >
            <li class="mx-1 mb-6 lg:mx-3">
              <ais-clear-refinements>
                <div slot-scope="{ canRefine, refine, createURL }">
                  <button
                    class="px-5 py-3 text-sm tracking-wider uppercase rounded-full transition-all text-blue-dark transition-500 hover:text-blue-dark hover:shadow-button"
                    :class="
                      canRefine ? 'bg-gray-lightest' : 'bg-white shadow-button'
                    "
                    :href="createURL()"
                    @click.prevent="refine"
                  >
                    All
                  </button>
                </div>
              </ais-clear-refinements>
            </li>
            <li
              class="mx-1 mb-6 lg:mx-3"
              v-for="item in items"
              :key="item.value"
            >
              <button
                class="px-5 py-3 text-sm tracking-wider uppercase rounded-full transition-all text-blue-dark transition-500 hover:text-blue-dark hover:shadow-button"
                :class="
                  item.isRefined ? 'bg-white shadow-button' : 'bg-gray-lightest'
                "
                :href="createURL(item.value)"
                @click.prevent="refine(item.value)"
              >
                {{ item.label }}
              </button>
            </li>
          </ul>
        </ais-menu>
      </div>

      <div class="block mb-16 md:hidden">
        <p class="mb-3 text-xl font-bold text-center text-blue-dark">
          Advanced Heat Pump Improvements
        </p>
        <ais-menu-dropdown :aisMenuOptions="improvements" menuAttribute="title">
        </ais-menu-dropdown>
      </div>

      <ais-infinite-hits>
        <template slot-scope="{ items }">
          <ul class="grid grid-cols-1" v-if="items.length">
            <li
              class="py-10 border-b border-gray-300"
              v-for="(entry, index) in items"
              :key="entry.objectID"
            >
              <div
                class="flex flex-row w-full"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                <div v-if="entry.icon.src" class="w-12">
                  <img
                    class="lazyload"
                    :src="entry.icon.src"
                    :data-srcset="entry.icon.srcset"
                    sizes="100vw"
                  />
                </div>
                <div class="px-3 w-full md:px-8 lg:px-6">
                  <h3 v-if="entry.title">
                    <a class="text-blue-gray" :href="entry.path">
                      {{ entry.title }}
                    </a>
                  </h3>
                  <div
                    v-if="entry.description"
                    class="mb-6 text-gray-muted"
                    v-html="entry.description"
                  ></div>
                  <a :href="entry.path" class="button-primary"> Learn More </a>
                </div>
              </div>
            </li>
          </ul>
          <div v-else>
            <div
              v-if="!initialRender"
              class="mx-auto w-full text-xl text-center text-blue-dark md:w-3/5"
            >
              <p>
                We are experiences difficulties displaying these programs.
                Please
                <a :href="`mailto:${helpAddress.fromEmail}`">e-mail</a> us about
                this issue to get it resolved ASAP!
              </p>
            </div>
          </div>
        </template>
      </ais-infinite-hits>
    </ais-instant-search>
  </div>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
import "instantsearch.css/themes/reset.css";
import AisMenuDropdown from "./AisMenuDropdown";

export default {
  name: "AhpImprovementsToggle",
  props: ["indexName"],
  data() {
    return {
      index: "",
      improvements: [],
      algoliaClient: algoliasearch(
        "68G5M92M1B",
        "c24543a92b3e155b20a0b69f1ca4b554"
      ),
    };
  },
  created() {
    // set index
    this.index = this.algoliaClient.initIndex(this.indexName);

    this.index.search({
      query: "",
      hitsPerPage: 1000,
    });

    // Get Location Facet
    this.index
      .searchForFacetValues({
        facetName: "title",
        facetQuery: "",
      })
      .then((facetHits) => {
        this.improvements = facetHits.facetHits;
      });
  },
  methods: {
    gtmTracking(label) {
      this.$gtm.trackEvent({
        event: "program-referral", // Event type [default = 'interaction'] (Optional)
        category: "Program Referral",
        action: "Programs",
        label: label,
        title: label,
        value: 1,
        noninteraction: false, // Optional
      });
    },
  },
};
</script>
